<div class="page-title-area">
  <div class="container">
    <div class="page-title-content">
      <ul>
        <li><a routerLink="/">Inicio</a></li>
        <li>
          <a routerLink="/configuracion-calendario">Configuracion del Calendario</a>
        </li>
        <li>{{ isEditMode ? 'Editar Evento' : 'Nuevo Evento' }}</li>
      </ul>
      <h2>{{ isEditMode ? 'Editar Evento en el Calendario' : 'Nuevo Evento en el Calendario' }}</h2>
    </div>
  </div>
</div>

<div class="andorra-apply-content ptb-70 animate__animated animate__fadeIn">
  <div class="container">
    <div class="row mx-auto">
      <div class="col-lg-12 col-md-12">
        <div class="apply-form">
          <form [formGroup]="form" (ngSubmit)="guardarEvento()">
            <div class="row">
              <div class="col-lg-12 col-md-12">
                <div class="form-group">
                  <mat-form-field
                    class="example-full-width"
                    appearance="fill"
                    [style.width.%]="100"
                  >
                    <mat-label>Título del Evento</mat-label>
                    <input
                      formControlName="titulo"
                      matInput
                      placeholder="Ej: Conferencia de Marketing"
                    />
                    <mat-error
                      *ngIf="
                        form.get('titulo')?.hasError('required') &&
                        form.get('titulo')?.touched
                      "
                      >El título es obligatorio.</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12 col-md-12">
                <div class="form-group">
                  <mat-form-field
                    class="example-full-width"
                    appearance="fill"
                    [style.width.%]="100"
                  >
                    <mat-label>Descripción</mat-label>
                    <textarea
                      formControlName="descripcion"
                      matInput
                      rows="3"
                    ></textarea>
                    <mat-error
                      *ngIf="
                        form.get('descripcion')?.hasError('required') &&
                        form.get('descripcion')?.touched
                      "
                      >La descripción es obligatoria.</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6 col-md-6">
                <div class="form-group">
                  <mat-form-field
                    class="example-full-width"
                    appearance="fill"
                    [style.width.%]="100"
                  >
                    <mat-label>Fecha y Hora de Inicio</mat-label>
                    <input
                      matInput
                      [ngxMatDatetimePicker]="pickerInicio"
                      formControlName="fechaInicio"
                      readonly
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="$any(pickerInicio)"
                    ></mat-datepicker-toggle>
                    <ngx-mat-datetime-picker
                      #pickerInicio
                      [showSpinners]="true"
                      [showSeconds]="false"
                      [stepHour]="1"
                      [stepMinute]="1"
                      [touchUi]="false"
                      [color]="'primary'"
                    >
                    </ngx-mat-datetime-picker>
                    <mat-error
                      *ngIf="
                        form.get('fechaInicio')?.hasError('required') &&
                        form.get('fechaInicio')?.touched
                      "
                      >La fecha y hora de inicio son obligatorias.</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>

              <div class="col-lg-6 col-md-6">
                <div class="form-group">
                  <mat-form-field
                    class="example-full-width"
                    appearance="fill"
                    [style.width.%]="100"
                  >
                    <mat-label>Fecha y Hora de Fin</mat-label>
                    <input
                      matInput
                      [ngxMatDatetimePicker]="pickerFin"
                      formControlName="fechaFin"
                      readonly
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="$any(pickerFin)"
                    ></mat-datepicker-toggle>
                    <ngx-mat-datetime-picker
                      #pickerFin
                      [showSpinners]="true"
                      [showSeconds]="false"
                      [stepHour]="1"
                      [stepMinute]="1"
                      [touchUi]="false"
                      [color]="'primary'"
                    >
                    </ngx-mat-datetime-picker>
                    <mat-error
                      *ngIf="
                        form.get('fechaFin')?.hasError('required') &&
                        form.get('fechaFin')?.touched
                      "
                      >La fecha y hora de fin son obligatorias.</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>

            <h3>Links del Evento</h3>

            <div formArrayName="links">
              <div
                *ngFor="let linkGroup of linksFormArray.controls; let i = index"
                [formGroupName]="i"
                class="row align-items-end mb-3"
              >
                <div class="col-lg-5 col-md-5">
                  <div class="form-group">
                    <mat-form-field
                      class="example-full-width"
                      appearance="fill"
                      [style.width.%]="100"
                    >
                      <mat-label>Etiqueta del Link</mat-label>
                      <input
                        formControlName="label"
                        matInput
                        placeholder="Ej: Sitio Web Oficial"
                      />
                      <mat-error
                        *ngIf="
                          linkGroup.get('label')?.hasError('required') &&
                          linkGroup.get('label')?.touched
                        "
                        >La etiqueta es obligatoria.</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <mat-form-field
                      class="example-full-width"
                      appearance="fill"
                      [style.width.%]="100"
                    >
                      <mat-label>URL del Link</mat-label>
                      <input
                        formControlName="link"
                        matInput
                        placeholder="Ej: https://www.ejemplo.com"
                      />
                      <mat-error
                        *ngIf="
                          linkGroup.get('link')?.hasError('required') &&
                          linkGroup.get('link')?.touched
                        "
                        >La URL es obligatoria.</mat-error
                      >
                      <mat-error
                        *ngIf="
                          linkGroup.get('link')?.hasError('pattern') &&
                          linkGroup.get('link')?.touched
                        "
                        >Formato de URL inválido.</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-1 col-md-1">
                  <button
                    type="button"
                    (click)="removeLink(i)"
                    class="btn btn-danger btn-sm"
                    [disabled]="isLoading"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12 col-md-12 text-end">
                <button
                  type="button"
                  (click)="addLink()"
                  class="btn btn-primary"
                  [disabled]="isLoading"
                >
                  Añadir Link
                </button>
              </div>
            </div>

            <br />

            <div class="row">
              <div class="col-lg-8 col-md-8">
                <div class="form-group">
                  <mat-form-field
                    class="example-full-width"
                    appearance="fill"
                    [style.width.%]="100"
                  >
                    <mat-label>Ubicación</mat-label>
                    <input
                      formControlName="ubicacion"
                      matInput
                      placeholder="Ej: Centro de Convenciones"
                    />
                    <mat-error
                      *ngIf="
                        form.get('ubicacion')?.hasError('required') &&
                        form.get('ubicacion')?.touched
                      "
                      >La ubicación es obligatoria.</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>

              <div class="col-lg-4 col-md-4">
                <div class="form-group">
                  <mat-form-field
                    class="example-full-width"
                    appearance="fill"
                    [style.width.%]="100"
                  >
                    <mat-label>Color del Evento</mat-label>
                    <input formControlName="color" type="color" matInput />
                    <mat-error
                      *ngIf="
                        form.get('color')?.hasError('required') &&
                        form.get('color')?.touched
                      "
                      >El color es obligatorio.</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6 col-md-6 col-xs-12">
                <div class="form-group">
                  <mat-form-field
                    class="example-full-width"
                    appearance="fill"
                    [style.width.%]="100"
                  >
                    <mat-label>Latitud</mat-label>
                    <input
                      formControlName="latitud"
                      matInput
                      placeholder="Latitud de la ubicación"
                      autocomplete="off"
                      (change)="updatesCoordinates()"
                      (input)="updateMarkerLocation()"
                    />
                    <mat-error *ngIf="form.get('latitud')?.hasError('pattern')"
                      >Ingrese una latitud válida.</mat-error
                    >
                    <mat-error
                      *ngIf="
                        form.get('latitud')?.hasError('required') &&
                        form.get('latitud')?.touched
                      "
                      >La latitud es obligatoria.</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>

              <div class="col-lg-6 col-md-6 col-xs-12">
                <div class="form-group">
                  <mat-form-field
                    class="example-full-width"
                    appearance="fill"
                    [style.width.%]="100"
                  >
                    <mat-label>Longitud</mat-label>
                    <input
                      formControlName="longitud"
                      matInput
                      placeholder="Longitud de la ubicación"
                      autocomplete="off"
                      (change)="updatesCoordinates()"
                      (input)="updateMarkerLocation()"
                    />
                    <mat-error *ngIf="form.get('longitud')?.hasError('pattern')"
                      >Ingrese una longitud válida.</mat-error
                    >
                    <mat-error
                      *ngIf="
                        form.get('longitud')?.hasError('required') &&
                        form.get('longitud')?.touched
                      "
                      >La longitud es obligatoria.</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <app-map></app-map>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-4">
                <button
                  type="button"
                  routerLink="/configuracion-calendario"
                  class="btn btn-warning"
                  [disabled]="isLoading"
                >
                  Cancelar
                </button>
              </div>

              <div class="col-lg-4 col-md-4">
                <button type="submit" [disabled]="form.invalid || isLoading">
                  {{ isEditMode ? 'Actualizar Evento' : 'Guardar Evento' }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<app-spinner
  [show]="isLoading"
  [text]="isEditMode ? 'Actualizando evento' : 'Guardando evento'"
  [type]="'fullscreen'"
  [animationStyle]="'scale'"
  [blurBackground]="true"
>
</app-spinner>